import { Box, Grid, Typography, useTheme } from '@mui/material';

export type MarketingStat = {
  value: string;
  label: string;
};

type MarketingStatRowProps = {
  stats: MarketingStat[];
};

export const MarketingStatRow = ({ stats }: MarketingStatRowProps) => {
  const theme = useTheme();
  return (
    <Grid container spacing={2} sx={{ my: 4 }}>
      {stats.map((s) => (
        <Grid item xs={6} md={3} key={s.label}>
          <Box
            sx={{
              textAlign: 'center',
              p: 2,
              borderRadius: 2,
              bgcolor: theme.palette.mainColors.background1,
              border: `1px solid ${theme.palette.greyShades.border1}`,
            }}
          >
            <Typography
              variant="h4"
              sx={{ fontWeight: 800, color: 'primary.main' }}
            >
              {s.value}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {s.label}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
